module.exports = __webpack_public_path__ + "assets/caac06c009ba3f774d04e1b4b5ff55c0.png";